import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { WorkspaceDTO } from '../types/workspaceDTO'

export const WORKSPACE_FRAGMENT: TypedDocumentNode<WorkspaceDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment WorkspaceFragment on Workspace {
    id
    active
    alerts {
      ...AlertFragment
    }
    createdAt
    crmId
    csManager {
      id
      firstName
      lastName
    }
    latestGamConnectionOrder {
      status
    }
    name
    networkCode
    pipedriveLink
    prebidManagerAccountId
    prebidManagerSampling
    priceGeniusAlwaysOn
    primaryCurrency
    updatedAt
  }
`
